import React, { Component } from 'react';
import FilteredList2 from './filteredList2';
import ProgramForm from './programForm';
import { end_point } from './helper';

class Programs2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterableFields: ["season", "ages", "division", "group_name", "type", "status", "start_date"],
      labelFields: [
        { "displayName":"Season", "name":"season", "size": "8%" },
        { "displayName":"Age Group", "name":"ages", "size": "12%" },        
        { "displayName":"Division", "name":"division", "size": "8%" },        
        { "displayName":"Group Name", "name":"group_name", "size": "35%" },
        { "displayName":"Type", "name":"type", "size": "10%" },
        { "displayName":"Status", "name":"status", "size": "9%" },
        { "displayName":"Start Date", "name":"start_date", "size": "12%"},
        { "displayName":"Clone", "name":"clone", "size": "6%" }
      ],
      endpoint: `${end_point('programs')}/programs`,
    }
  }

  render() {
    return(
      <FilteredList2 
        heading="Programs"
        filterableFields={this.state.filterableFields}
        labelFields={this.state.labelFields}
        endpoint={this.state.endpoint}
        modalClassName="programs-modal-shell">
        <ProgramForm/>
      </FilteredList2>
    );
  }
}

export default Programs2;
